import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable, Subscription, of, startWith, switchMap, distinctUntilChanged} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {Client} from '../../api/model/client';
import {ClientService} from '../../api/client.service';

@Component({
  selector: 'app-client-autocomplete',
  templateUrl: './client-autocomplete.component.html',
  styleUrls: ['./client-autocomplete.component.sass'],
})
export class ClientAutocompleteComponent implements OnDestroy {
  @Input() label = 'Client Name';
  @Input() placeholder = 'Ex. LNDT';
  @Output() clientIdChange = new EventEmitter<string | null>();

  filteredClients: Observable<Client[]> = of([]);

  private _control!: FormControl<string | null>;
  private _controlSub?: Subscription;
  private _clientId: string | null = null;
  private lastSelectedClientName: string | null = null;

  @Input()
  get clientId(): string | null {
    return this._clientId;
  }

  set clientId(v: string | null) {
    this._clientId = v;
    if (v !== null && this._control) {
      this.lastSelectedClientName = this._control.value;
    }
  }

  constructor(private clientService: ClientService) {
  }

  @Input({required: true})
  get control(): FormControl<string | null> {
    return this._control;
  }

  set control(c: FormControl<string | null>) {
    this._control = c;
    this.setupSubscriptions();
  }

  private setupSubscriptions() {
    this._controlSub?.unsubscribe();
    this.lastSelectedClientName = this._control.value;
    this.filteredClients = this._control.valueChanges.pipe(
      startWith(this._control.value || ''),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(val => this.clientService.search(val || '')),
    );
    this._controlSub = this._control.valueChanges.subscribe(val => {
      if (this._clientId === null) return;
      if (val !== this.lastSelectedClientName) {
        this._clientId = null;
        this.lastSelectedClientName = null;
        this.clientIdChange.emit(null);
      }
    });
  }

  onOptionSelected($event: MatAutocompleteSelectedEvent) {
    const id = $event.option.id || null;
    const name = $event.option.value || null;
    this._clientId = id;
    this.lastSelectedClientName = name;
    this.clientIdChange.emit(id);
  }

  ngOnDestroy() {
    this._controlSub?.unsubscribe();
  }
}
